<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_DETALHAR_COMANDA')">
            <div class="z-1 text-center">
                <div class="text-900 font-bold text-7xl mb-4">Acesso Negado</div>
                <p class="line-height-3 mt-0 mb-5 text-700 text-xl font-medium">Voçê não possui permissão
                    de acesso a esta página</p>
                <p-button [routerLink]="['/apps/caixa']"
                    styleClass="p-button-help font-medium p-button-raised">Voltar</p-button>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_DETALHAR_COMANDA')">
            <h4>Comanda</h4>
            <form>
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                    </div>

                    <div class="flex justify-content-center" *ngIf="isExibirSpinnerPrincipal()">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                </div>
                <div class="formgroup" *ngIf="comanda && !isExibirSpinnerPrincipal()">

                    <div class="p-fluid p-formgrid grid pt-5 px-3">

                        <div class="col-12 card-simple">
                            <div class="p-fluid p-formgrid grid">
                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Data da Comanda</label>
                                    <label class="label-inferior">{{ comanda.dataComanda |
                                        date:'dd/MM/yyyy' }}</label>
                                </div>
                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Nº da Comanda</label>
                                    <label class="label-inferior">{{ comanda.numeroComanda }}</label>
                                </div>
                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Status</label>
                                    <label class="label-inferior">{{ comanda.statusComanda
                                        }}</label>
                                </div>
                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Saldo Comanda</label>
                                    <label class="label-inferior">{{ totalPagamentos - valorTotalItensComDesconto | currency:'BRL'}}</label>
                                </div>
                            </div>
                            <div class="p-fluid p-formgrid grid">
                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">Cliente</label>
                                    <label class="label-inferior">{{ comanda.cliente?.nome }}</label>
                                </div>
                                <div class="form-group field col-12 md:col-6 xl:col-2">
                                    <label class="label-superior">CPF</label>
                                    <label class="label-inferior">{{ comanda.cliente?.cpf | cpfPipe }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 card-simple mt-5">
                            <span class="text-base font-bold">Itens</span>
                            <p-table #dt1 [value]="listaItensComanda" dataKey="id" [rows]="10" [rowHover]="true"
                                styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="stack"
                                styleClass=" p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Quantidade</th>
                                        <th>Valor Unitário</th>
                                        <th>Desconto Item</th>
                                        <th>Valor Total</th>
                                        <th>Profissional</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <label>{{ item.descricaoItem }}
                                                <span class="product-badge status-instock mr-1"
                                                    *ngIf="item.pacote">PACOTE</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>{{ item.quantidadeItem }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.valorItem | currency:'BRL' }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.descontoItem.toFixed(2) }}%</label>
                                        </td>
                                        <td>
                                            <label>{{ item.quantidadeItem * item.valorItem | currency:'BRL'
                                                }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.profissionalConsulta ?
                                                item.profissionalConsulta.nomeProfissional : 'INDEFINIDO' }}
                                            </label>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div class="flex align-items-center justify-content-between">
                                        <div>
                                            Há {{listaItensComanda ? listaItensComanda.length : 0 }} itens
                                            inseridos
                                            na Comanda.
                                        </div>
                                        <div class="flex-column hidden md:flex" *ngIf="listaItensComanda.length > 0">
                                            <span class="text-right">Total: {{ valorTotalItensSemDesconto |
                                                currency:'BRL' }}</span>
                                            <span>Total c/ desconto: {{ valorTotalItensComDesconto |
                                                currency:'BRL' }}</span>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum Pagamento Cadastrado.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>

                        <div class="col-12 card-simple mt-5">
                            <span class="text-base font-bold">Pagamentos</span>
                            <p-table #dt2 [value]="listaPagamentos" dataKey="id" [rows]="10" [rowHover]="true"
                                [paginator]="false" responsiveLayout="stack" styleClass=" p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Valor</th>
                                        <th>Documento</th>
                                        <th>Prazo</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item let-i="rowIndex">
                                    <tr>
                                        <td>
                                            <label>{{ item.tipoPagamento.descricao }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.valorFluxo | currency:'BRL' }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.identificacao }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.prazo }} dias</label>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div class="flex align-items-center justify-content-between">
                                        <div>
                                            Há {{listaPagamentos.length}} pagamentos realizados.
                                        </div>
                                        <div>
                                            Total: {{ totalPagamentos | currency:'BRL' }}
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum Item Cadastrado.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>


                    </div>

                </div>
            </form>
        </div>
    </div>
</div>